import React from "react";
import PageCover from "../components/PageCover";
import AboutCards from "../components/AboutUs/AboutCards";
import WorkingProcess from "../components/AboutUs/WorkingProgress";
import OurTeamSection from "../components/AboutUs/OurTeamSection";
import fleet_sunrise from "../assets/fleet_sunrise.jpg";
import JoinUs from "../components/AboutUs/JoinUs";
const About = () => {
  return (
    <div>
      <PageCover
        title="About Us"
        subtitle="Built on trust. Driven by excellence."
        breadcrumb="About"
        bgImage={fleet_sunrise}
      />
      <AboutCards />
      <WorkingProcess />
      <OurTeamSection />
      <JoinUs />
    </div>
  );
};

export default About;
